import React from 'react';
import { useSelector } from 'react-redux';
import styles from '../styles.module.scss';
import { Select } from '@lion-design/core';
import { RootState } from '@Redux/search/store';

interface Option {
    text: string;
    value: number | string;
}

interface DropDownsProps {
    defaultSelect: number;
    options: Option[];
    onSelect: (value: number) => void;
}

const DropDowns: React.FC<DropDownsProps> = ({ defaultSelect, options, onSelect }) => {
    const { SwitchListBy } = useSelector((state: RootState) => state.search);

    const isCards = SwitchListBy === 'List';

    const moduleName = 'dropDowns';
    const finalOptions = options.filter((option) =>
        isCards ? option.value !== 'List' : option.value !== 'Cards'
    );
    const selectProps = {
        data: finalOptions,
        defValue: defaultSelect,
        onChange: (value: any) => {
            onSelect(value);
        },
    };

    return (
        <div className={styles[`${moduleName}`]}>
            <Select {...selectProps} />
        </div>
    );
};

export default DropDowns;
